var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBasket = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26593 19.8221C7.27719 19.9234 7.3628 20 7.46471 20H16.2496C16.3515 20 16.4371 19.9234 16.4483 19.8221L17.5467 9.93637C17.5599 9.81789 17.4672 9.71428 17.348 9.71428L6.3663 9.71428C6.24709 9.71428 6.15436 9.81789 6.16752 9.93637L7.26593 19.8221ZM14.3428 6.28128C14.2324 6.28128 14.1428 6.19174 14.1428 6.08128V4.2C14.1428 4.08954 14.0533 4 13.9428 4H9.77142C9.66096 4 9.57142 4.08954 9.57142 4.2V6.08147C9.57142 6.19186 9.482 6.28137 9.37162 6.28148L5.19981 6.28551C5.08943 6.28562 5 6.37513 5 6.48551L5 9.23077C5 9.40905 5.21562 9.49824 5.34156 9.37206L6.08204 8.63014C6.11956 8.59255 6.17049 8.57142 6.2236 8.57142L17.4886 8.57142C17.5416 8.57142 17.5925 8.59249 17.63 8.63L18.3729 9.37286C18.4989 9.49885 18.7143 9.40962 18.7143 9.23144V6.48128C18.7143 6.37082 18.6247 6.28128 18.5143 6.28128H14.3428ZM12.9845 6.08128C12.9845 6.19174 12.895 6.28128 12.7845 6.28128L10.9143 6.28128C10.8038 6.28128 10.7143 6.19174 10.7143 6.08128V5.34064C10.7143 5.23018 10.8038 5.14064 10.9143 5.14064L12.7845 5.14064C12.895 5.14064 12.9845 5.23018 12.9845 5.34064V6.08128Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBasket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/basket.72cdd4fc.svg";
export { ForwardRef as ReactComponent };